import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';

const MobileHandoffPage: React.FC = () => {
    const { currentUser } = useAuth();
    const [status, setStatus] = useState<'idle' | 'sending' | 'success' | 'error'>('idle');

    const handleEmailLink = async () => {
        if (!currentUser?.email) {
            setStatus('error');
            return;
        }

        setStatus('sending');
        try {
            await firebase.firestore().collection('mail').add({
                to: currentUser.email,
                message: {
                    subject: "RaceLineIQ Login Link",
                    text: "Here is your link to log into RaceLineIQ on your desktop:\n\nhttps://racelineiq.com\n\nConnect your ride data to reconstruct the peloton!",
                    html: `
                        <div style="font-family: sans-serif; color: #333;">
                            <h2>Your RaceLineIQ Login Link</h2>
                            <p>Here is your link to log into RaceLineIQ on your desktop:</p>
                            <p>
                                <a href="https://racelineiq.com" style="background-color: #0891b2; color: white; padding: 10px 20px; text-decoration: none; border-radius: 5px; display: inline-block;">
                                    Log In to RaceLineIQ
                                </a>
                            </p>
                            <p>If the button doesn't work, copy this link: https://racelineiq.com</p>
                            <p>Connect your ride data to reconstruct the peloton!</p>
                            <p>- The RaceLineIQ Team</p>
                        </div>
                    `
                }
            });
            setStatus('success');
        } catch (error) {
            console.error("Failed to send email:", error);
            setStatus('error');
        }
    };

    return (
        <div className="flex flex-col items-center justify-center min-h-screen p-6 text-center animate-fade-in relative overflow-hidden">
            <div className="absolute inset-0 flex items-center justify-center pointer-events-none opacity-20">
                <div className="w-96 h-96 bg-cyan-500 rounded-full blur-[100px]"></div>
            </div>
            <div className="relative z-10 w-full max-w-sm">
                <div className="text-6xl mb-6">🚀</div>
                <h2 className="text-3xl font-bold text-white mb-4">You're All Set!</h2>
                <p className="text-gray-300 text-lg mb-8 leading-relaxed">
                    Your future rides will now automatically sync to RaceLineIQ.
                </p>
                <div className="bg-gray-800 border border-gray-700 rounded-2xl p-6 mb-8 text-left">
                    <div className="flex items-center gap-3 mb-2">
                        <svg className="w-6 h-6 text-cyan-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path></svg>
                        <h3 className="text-white font-bold text-lg">Next Steps</h3>
                    </div>
                    <p className="text-gray-400 text-sm">
                        To view your telemetry, full maps, and AI insights, log into RaceLineIQ on your desktop computer.
                    </p>
                </div>
                <button 
                    onClick={handleEmailLink} 
                    disabled={status === 'sending' || status === 'success'}
                    className={`w-full font-bold py-4 rounded-xl active:scale-95 transition-transform mb-2 disabled:opacity-80 disabled:cursor-not-allowed ${
                        status === 'success' ? 'bg-green-600 text-white' : 'bg-cyan-600 text-white hover:bg-cyan-500'
                    }`}
                >
                    {status === 'sending' ? 'Sending...' : status === 'success' ? 'Email Sent!' : 'Email me a login link'}
                </button>
                {status === 'error' && (
                    <p className="text-red-400 text-sm">Failed to send email. Please try again.</p>
                )}
            </div>
        </div>
    );
};

export default MobileHandoffPage;